export default (state, action) => {
  const { deviceId, newDeviceUiConfig } = action.payload
  const modifiedDevice = state.devices.find(device => device.id === deviceId)
  const devices = state.devices.filter(device => device.id !== deviceId)
  const newDevice = { ...modifiedDevice, uIConfig: newDeviceUiConfig }
  return { ...state, devices: [...devices, newDevice] }
}
